<template>
  <v-snackbar v-model="show" :bottom="true" :timeout="0">
    <!-- Notification message -->
    {{ notification.text }}
    <!-- Notification close button (default) -->
    <v-btn v-if="!(notification.buttons && notification.buttons.length)" dark text icon @click="next">
      <v-icon>clear</v-icon>
    </v-btn>
    <!-- Notification action buttons (if any) -->
    <v-btn v-for="(button, i) in notification.buttons || []" :key="i" dark text icon @click="button.action">
      {{ button.text }}
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'global-snackbar',
  data () {
    return {
      notification: {},
      to: null
    }
  },
  computed: {
    isNetworkError () {
      return this.$store.state.errors.networkError
    },
    isGenericError () {
      return this.$store.state.errors.genericError
    },
    isServerError () {
      return this.$store.state.errors.serverError
    },
    isSaved () {
      return this.$store.state.savedSnackbar
    },
    isArchived () {
      return this.$store.state.archivedSnackbar
    },
    isSnackbar () {
      return this.$store.state.snackbar !== false
    },
    // notification queue
    notifications () {
      const types = {
        'networkError': {
          show: this.isNetworkError,
          text: this.$t('network-error'),
          to: 10000
        },
        'genericError': {
          show: this.isGenericError,
          text: this.$t(this.genericErrorText),
          to: 10000
        },
        'serverError': {
          show: this.isServerError,
          text: this.$t('server-error'),
          to: 10000
        },
        'savedSnackbar': {
          show: this.isSaved,
          text: this.$t('saved'),
          to: 4000
        },
        'archivedSnackbar': {
          show: this.isArchived,
          text: this.$t('archived'),
          to: 4000
        },
        'snackbar': this.snackbar
      }

      return Object.keys(types).reduce((notifications, type) => {
        let { show, text, to } = types[type]
        if (show) {
          notifications.push({
            type,
            text,
            to
          })
        }
        return notifications
      }, [])
    },
    // snackbar display state
    show: {
      get () {
        return this.notifications.length > 0
      },
      // close current notification
      set (val) {
        // nada
      }
    },
    genericErrorText () {
      let errors = Array.isArray(this.$store.state.errors.errorTexts)
        ? this.$store.state.errors.errorTexts
        : [ 'something-went-wrong' ]

      return errors
        .map(err => err.charAt(0).toUpperCase() + err.slice(1))
        .join(', ')
    },
    snackbar () {
      const snackbar = this.$store.state.snackbar
      return {
        show: this.isSnackbar,
        text: snackbar.message || '',
        to: snackbar.timeout || 5000,
        buttons: snackbar.buttons || []
      }
    }
  },
  methods: {
    next () {
      clearTimeout(this.to)
      switch (this.notification.type) {
        case 'snackbar':
        case 'savedSnackbar':
        case 'archivedSnackbar':
          this.$store.commit('setFlat', { param: this.notification.type, val: false })
          break
        case 'networkError':
        case 'genericError':
        case 'serverError':
          this.$store.commit('setError', { errorType: this.notification.type, val: false })
          break
      }
    }
  },
  watch: {
    // set current notification
    notifications: {
      handler: function (notifications) {
        if (notifications.length) {
          let notification = notifications[0]
          if (notification.to) {
            clearTimeout(this.to)
            this.to = setTimeout(() => this.next(), notification.to)
          }
          this.notification = notification
        } else {
          this.notification = {}
        }
      },
      deep: true
    }
  }
}
</script>
